export default __webpack_public_path__ + "static/media/S-046.b405b9e0.png";